import { JoinedFormFieldProps } from 'types';
import { NextLink } from 'components/NextLink';
import { AGREEMENT_DESCRIPTION, AGREEMENT_HEADER } from 'consts';

import styles from '../SignUp.module.scss';

export const getAgreementFields = (): Array<JoinedFormFieldProps> => [
  {
    type: 'title',
    fieldName: 'title',
    value: AGREEMENT_HEADER,
  },
  {
    type: 'description',
    fieldName: 'value',
    value: AGREEMENT_DESCRIPTION,
  },
  {
    type: 'component',
    fieldName: 'link1',
    child: <NextLink href="/terms-of-use" title="Terms and Conditions" className={styles.agreementLink} newTab />,
  },
  {
    type: 'component',
    fieldName: 'link2',
    child: <NextLink href="/privacy-policy" title="Privacy Policy" className={styles.agreementLink} newTab />,
  },
];
